import style from "./style.module.css";

export default function TabContainer(props) {

  const { children } = props;
  return (
    <div {...props}>
      <div className={style.tab_container}>
        {children}
      </div>
    </div>
  )
}